module.exports = __webpack_public_path__ + "img/teams_onboarding_step_2_icon.b657f56e.svg";